import React from "react";
import { useNavigate } from "react-router-dom";
import backIcon from '@/assets/images/svg/stepper/back-icon.svg';

const BackButton = ({ text = "Back", onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-back ${className}`}
      onClick={handleBack}
    >
        <img src={backIcon} alt="back-button" />
      {text}
    </button>
  );
};

export default BackButton;